export default __webpack_public_path__ + "static/media/mobile-link.88a5b62e.webp";